import ReportLayout from 'src/pages/Reports/Common/report/ReportLayout';
import ReportDetails from 'src/pages/Reports/Common/report/ReportDetails';

const CharitableSolicitationsReport = () => (
  <ReportLayout title="Clerk Charitable Solicitations Report">
    <ReportDetails
      title="Report Details"
      downloadEndpoint="charity_solicitor_permit_application/download"
    />
  </ReportLayout>
);

export default CharitableSolicitationsReport;
